module.exports = __webpack_public_path__ + "img/banner-escritorio.6836255b.png";